// frontend/src/components/Common/ConfirmacaoModal.jsx (0.1.8)

import React from "react";
import { AlertTriangle } from "lucide-react"; 
import Modal from "../UI/Modal"; // 🛑 Usando o componente Modal refatorado
import PrimaryButton from "./PrimaryButton"; // Usando o PrimaryButton da refatoração anterior

/**
 * Modal de confirmação genérico e reutilizável.
 * Agora utiliza o Modal.js para animações e fundo (backdrop-blur).
 */

const ConfirmacaoModal = ({
    isOpen,
    onClose,
    titulo = "Confirmar Ação",
    mensagem = "Tem certeza de que deseja continuar?",
    onConfirm,
    confirmText = "Confirmar",
    cancelText = "Cancelar",
    showMotivoInput = false,
    motivoValue = '',
    onMotivoChange = null,
}) => {
    // Passamos o `isOpen`, `onClose` e `title` para o componente base Modal
    // E usamos `hideHeader` como true para construirmos o layout interno aqui
    return (
        <Modal 
            isOpen={isOpen} 
            onClose={onClose} 
            title={titulo} // Título é passado, mas hideHeader é true
            size="md" // Um tamanho menor é ideal para modais de confirmação
            hideHeader={true} // Esconde o header padrão do Modal.js
        >
            <div className="flex flex-col items-center text-center p-2"> 
                {/* Ícone de alerta (opcional) */}
                <AlertTriangle className="h-10 w-10 text-yellow-500 mb-4" /> 

                {/* Cabeçalho */}
                <h2 className="text-xl font-bold text-gray-800 mb-2">
                    {titulo}
                </h2>

                {/* Corpo */}
                <div 
                    className="text-gray-600 text-base leading-relaxed mb-6"
                    dangerouslySetInnerHTML={{ 
                        __html: mensagem.replace(/\*\*(.*?)\*\*/g, '<strong class="text-gray-900">$1</strong>')
                    }}
                />
                
                {/* Campo de motivo do cancelamento (se necessário) */}
                {showMotivoInput && (
                    <div className="w-full mb-4">
                        <label htmlFor="motivo-cancelamento" className="block text-sm font-medium text-gray-700 mb-2">
                            Motivo do Cancelamento <span className="text-red-500">*</span>
                        </label>
                        <textarea
                            id="motivo-cancelamento"
                            value={motivoValue}
                            onChange={(e) => onMotivoChange && onMotivoChange(e.target.value)}
                            placeholder="Digite o motivo do cancelamento..."
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 resize-none"
                            rows={3}
                            required
                        />
                    </div>
                )}

                {/* Rodapé / Ações */}
                <div className="flex justify-center gap-3 w-full sm:w-auto">
                    {/* Botão Cancelar (Cinza) */}
                    <PrimaryButton
                        onClick={onClose}
                        className="!bg-gray-200 !text-gray-700 hover:!bg-gray-300 !shadow-none"
                    >
                        {cancelText}
                    </PrimaryButton>
                    
                    {/* Botão Confirmar (Verde - padrão do sistema) */}
                    <PrimaryButton
                        onClick={onConfirm}
                        className="!bg-higeia-medium hover:!bg-higeia-dark !text-white !shadow-sm hover:!shadow-md transition-all duration-200"
                    >
                        {confirmText}
                    </PrimaryButton>
                </div>
            </div>
        </Modal>
    );
};

export default ConfirmacaoModal;